import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Parametre} from '../models/parametre.model';
import {ParametreFitlerDTO} from '../models/filtreParametre.model';
import {HttpClient} from '@angular/common/http';
import {Pageable} from '../models/pageable.model';
import {ParametreEnum} from '../models/enum/parametre.enum';
import {tap} from 'rxjs/operators';
import {CacheableObservable} from '../decorators/cacheable.directive';

@Injectable({providedIn: 'root'})
export class ParametreService {

  private readonly parametreTypeCache: Map<ParametreEnum, Parametre[]> = new Map<ParametreEnum, Parametre[]>();

  constructor(private readonly http: HttpClient) {
  }

  getListParametre(paramsDTO: ParametreFitlerDTO): Observable<Pageable<Parametre>> {
    return this.http.post<Pageable<Parametre>>(environment.apiPathV2 + 'parametre/filter', paramsDTO);
  }

  @CacheableObservable({ time: { hours: 1 } })
  getParametreByTypes(type: ParametreEnum): Observable<Parametre[]> {

    if (this.parametreTypeCache.has(type)) {
      return of(this.parametreTypeCache.get(type));
    }

    return this.http.get<Parametre[]>(`${environment.apiPathV2}parametre/${type}`)
      .pipe(tap(parametres => {
        if (
          [ParametreEnum.DIMENSION_ECHAFAUDAGE, ParametreEnum.DIMENSION_CALORIFUGEAGE, ParametreEnum.DIMENSION_NETTOYAGE].includes(type)) {
          this.parametreTypeCache.set(type, parametres);
        }
      }));
  }

  @CacheableObservable({ time: { hours: 1 } })
  getListParametreByTypeAndUsine(type: ParametreEnum, idUsine: number): Observable<Parametre[]> {
    return this.http.get<Parametre[]>(`${environment.apiPathV2}parametre/${type}/${idUsine}`);
  }

  updateParametre(params: Parametre): Observable<Parametre> {
    return this.http.put<Parametre>(environment.apiPathV2 + 'parametre', params);
  }

  createParametre(params: Parametre): Observable<Parametre> {
    return this.http.post<Parametre>(environment.apiPathV2 + 'parametre/create', params)
  }

  deleteParametre(id: number): Observable<unknown> {
    return this.http.delete(environment.apiPathV2 + 'parametre/' + id)
  }

  getListParametreType(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiPathV2 + 'parametre/parametre-type');
  }

  public clearCache(): void {
    this.parametreTypeCache.clear();
  }
}
